import { Icon } from '@/components/Icon'
import styles from './ArchivedItemsIndicator.module.css'

export interface ArchivedItemsIndicatorProps {
  count: number
}

export function ArchivedItemsIndicator({ count }: ArchivedItemsIndicatorProps) {
  return (
    <div className={styles.root}>
      <Icon name="info" size={20} />
      <span> {count} items archived </span>
    </div>
  )
}
